import { baseApi } from "@/app/store/api/baseApi";

import type { EmailProviderOption } from "../model/providers";

export interface EmailConnectionStatus {
  status: "disconnected" | "pending" | "connected" | "error" | string;
  provider: EmailProviderOption["id"] | null;
  email_address: string;
  connected_at?: string | null;
  last_error?: string;
}

const emailApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    emailConnection: builder.query<EmailConnectionStatus, void>({
      query: () => ({ url: "/email-integration/connection/" }),
      providesTags: [{ type: "EmailConnection", id: "STATUS" }],
    }),
    emailConnect: builder.mutation<{ authorize_url: string }, { provider: EmailProviderOption["id"] }>({
      query: (body) => ({
        url: "/email-integration/connect/",
        method: "POST",
        body,
      }),
    }),
    emailDisconnect: builder.mutation<EmailConnectionStatus, void>({
      query: () => ({
        url: "/email-integration/disconnect/",
        method: "POST",
      }),
      invalidatesTags: [{ type: "EmailConnection", id: "STATUS" }],
    }),
  }),
});

export const {
  useEmailConnectionQuery,
  useEmailConnectMutation,
  useEmailDisconnectMutation,
} = emailApi;
